import i18n from "../../i18n";
import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import {Icon} from "@material-ui/core";

const GraphQlError = ({label, component, variant, color, size, ...props}) => (
    <Typography component={component || 'span'} variant={variant || "body2"} color={color || 'error'} {...props}>
        <Icon
            style={{marginRight: 5}}
        >
            error_outline
        </Icon>
        {label || (i18n.get('default.error.subTitle'))}
    </Typography>
);

export default GraphQlError;
